import { Badge } from '@/shared/components/ui/Badge/Badge';

import { type SidebarNavBadgeProps } from './SidebarNavBadge.types';
import { useSidebarNavBadgeLogic } from './useSidebarNavBadgeLogic';

/** A count worn at the end of a nav row. Pure presentation; the logic is in the hook. */
export function SidebarNavBadge(props: SidebarNavBadgeProps) {
  const { isShown, text, accessibleLabel } = useSidebarNavBadgeLogic(props);

  if (!isShown) return null;

  return (
    <Badge tone="info" className="ms-auto shrink-0 tabular-nums" aria-label={accessibleLabel}>
      {text}
    </Badge>
  );
}
